var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "_profile-details" }, [
    _c(
      "div",
      { staticClass: "w-12/12" },
      [
        _c(
          "div",
          {
            staticClass:
              "grid justify-items-center grid-cols-1 bg-grey bg-opacity-25 rounded-t-lg p-5",
          },
          [
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "overlay-container z-20",
                  on: {
                    mouseenter: function ($event) {
                      _vm.uploadOverlay = true
                    },
                    mouseleave: function ($event) {
                      _vm.uploadOverlay = false
                    },
                    click: function ($event) {
                      _vm.avatarEditor.visible = true
                    },
                  },
                },
                [
                  _vm.uploadOverlay
                    ? _c("feather-icon", {
                        staticClass:
                          "overlayed flex-shrink z-10 my-0 inset-0 cursor-pointer bg-contain rounded-full bg-black bg-opacity-75",
                        attrs: {
                          icon: "CameraIcon",
                          svgClasses:
                            "mx-auto my-0 w-10 h-10 text-primary opacity-75",
                        },
                      })
                    : _vm._e(),
                  _c("vs-avatar", {
                    key: _vm.key,
                    staticClass:
                      "border-white border-5 m-0 border-solid ring-inset",
                    attrs: { src: _vm.myProfilePicture, size: "100px" },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "grid grid-rows-2" }, [
              _c("span", { staticClass: "text-lg text-center font-semibold" }, [
                _vm._v(_vm._s(_vm.user.name + " " + _vm.user.surname)),
              ]),
              _c("span", { staticClass: "text-sm sm:text-md text-center" }, [
                _vm._v(_vm._s(_vm.user.email)),
              ]),
            ]),
          ]
        ),
        _c(
          "vx-card",
          { staticClass: "relative text-base leading-loose mb-5" },
          [
            _c(
              "h4",
              { staticClass: "mx-auto text-center lg:text-left mb-10 lg:mb-5" },
              [_vm._v(" Dados Usuário ")]
            ),
            _c(
              "vs-row",
              { staticClass: "w-full gap-2" },
              [
                _c("vs-input", {
                  staticClass: "flex-grow",
                  attrs: { label: "Nome" },
                  model: {
                    value: _vm.user.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.user, "name", $$v)
                    },
                    expression: "user.name",
                  },
                }),
                _c("vs-input", {
                  staticClass: "flex-grow",
                  attrs: { label: "Sobrenome" },
                  model: {
                    value: _vm.user.surname,
                    callback: function ($$v) {
                      _vm.$set(_vm.user, "surname", $$v)
                    },
                    expression: "user.surname",
                  },
                }),
              ],
              1
            ),
            _c("vs-row", { staticClass: "mb-2 gap-2" }, [
              _c(
                "div",
                { staticClass: "flex-grow" },
                [
                  _c(
                    "vs-select",
                    {
                      staticClass: "w-full hover:text-primary",
                      attrs: { label: "Gênero:" },
                      model: {
                        value: _vm.user.gender,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "gender", $$v)
                        },
                        expression: "user.gender",
                      },
                    },
                    [
                      _c("vs-select-item", {
                        attrs: { value: "F", text: "Feminino" },
                      }),
                      _c("vs-select-item", {
                        attrs: { value: "M", text: "Masculino" },
                      }),
                      _c("vs-select-item", {
                        attrs: { value: "U", text: "Prefiro Não Dizer" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-grow" },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "mr-2 align-middle vs-select--label inline-block",
                      attrs: { for: "birthdate" },
                    },
                    [_vm._v("Data de Nascimento:")]
                  ),
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { id: "birthdate", name: "birthdate", type: "date" },
                    model: {
                      value: _vm.user.birthdate,
                      callback: function ($$v) {
                        _vm.$set(_vm.user, "birthdate", $$v)
                      },
                      expression: "user.birthdate",
                    },
                  }),
                  _vm.user.birthdate && !_vm.isOfAge
                    ? _c("span", { staticClass: "text-danger text-sm" }, [
                        _vm._v(
                          " É necessário ter pelo menos " +
                            _vm._s(_vm.minAge) +
                            " anos. "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("vs-row", [
              _c("label", { staticClass: "w-full" }, [
                _vm._v("Cadastrado desde:"),
              ]),
              _c("span", { staticClass: "text-base font-semibold" }, [
                _vm._v(_vm._s(_vm.sinceLabel)),
              ]),
            ]),
            _c(
              "vs-row",
              [
                _c(
                  "vs-col",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "float-right",
                        on: { click: _vm.updateProfile },
                      },
                      [_vm._v("Salvar")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "vs-popup",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.left",
                value: {
                  content:
                    "Clique no editor ou arraste um arquivo para alterar a imagem.",
                  delay: { show: 500, hide: 100 },
                  classes: "tooltipZFix",
                },
                expression:
                  "{\n        content: 'Clique no editor ou arraste um arquivo para alterar a imagem.',\n        delay: { show: 500, hide: 100 },\n        classes: 'tooltipZFix'\n      }",
                modifiers: { left: true },
              },
            ],
            attrs: { title: "Foto Perfil", active: _vm.avatarEditor.visible },
            on: {
              "update:active": function ($event) {
                return _vm.$set(_vm.avatarEditor, "visible", $event)
              },
            },
          },
          [
            _c(
              "vs-row",
              { staticClass: "grid place-items-center" },
              [
                _c("avatar-editor", {
                  ref: "avatareditor",
                  staticClass:
                    "border-1 border-primary border-double vs-col place-self-center",
                  staticStyle: { height: "256px" },
                  attrs: {
                    width: 200,
                    height: 200,
                    scale: _vm.avatarEditor.scale,
                    rotation: _vm.avatarEditor.rotation,
                    borderRadius: 200,
                    image: _vm.myProfilePicture,
                  },
                  on: { "vue-avatar-editor:image-ready": _vm.onImageReady },
                }),
                _c(
                  "div",
                  {
                    staticClass:
                      "EditorButtons mt-2 flex justify-between w-1/3 space-x-3",
                  },
                  [
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.auto",
                          value: {
                            content: "Ampliar",
                            delay: { show: 500, hide: 100 },
                            classes: "tooltipZFix",
                          },
                          expression:
                            "{\n              content: 'Ampliar',\n              delay: { show: 500, hide: 100 },\n              classes: 'tooltipZFix'\n            }",
                          modifiers: { auto: true },
                        },
                      ],
                      attrs: {
                        icon: "ZoomInIcon",
                        svgClasses: _vm.aditionalStyleWhen(
                          _vm.zoomingIn,
                          "w-8 h-8 lg:w-5 lg:h-5 hover:primary",
                          "primary"
                        ),
                      },
                      on: {
                        mousedown: function ($event) {
                          return _vm.doZoom(1)
                        },
                        mouseup: function ($event) {
                          return _vm.doZoom(0)
                        },
                        click: function ($event) {
                          return _vm.tinyZoom(1)
                        },
                      },
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.auto",
                          value: {
                            content: "Reduzir",
                            delay: { show: 500, hide: 100 },
                            classes: "tooltipZFix",
                          },
                          expression:
                            "{\n              content: 'Reduzir',\n              delay: { show: 500, hide: 100 },\n              classes: 'tooltipZFix'\n            }",
                          modifiers: { auto: true },
                        },
                      ],
                      attrs: {
                        icon: "ZoomOutIcon",
                        svgClasses: _vm.aditionalStyleWhen(
                          _vm.zoomingOut,
                          "w-8 h-8 lg:w-5 lg:h-5 hover:primary",
                          "primary"
                        ),
                      },
                      on: {
                        mousedown: function ($event) {
                          return _vm.doZoom(-1)
                        },
                        mouseup: function ($event) {
                          return _vm.doZoom(0)
                        },
                        click: function ($event) {
                          return _vm.tinyZoom(-1)
                        },
                      },
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.auto",
                          value: {
                            content: "Girar sentido horário",
                            delay: { show: 500, hide: 100 },
                            classes: "tooltipZFix",
                          },
                          expression:
                            "{\n              content: 'Girar sentido horário',\n              delay: { show: 500, hide: 100 },\n              classes: 'tooltipZFix'\n            }",
                          modifiers: { auto: true },
                        },
                      ],
                      attrs: {
                        icon: "RotateCwIcon",
                        svgClasses: _vm.aditionalStyleWhen(
                          _vm.rotatingCW,
                          "w-8 h-8 lg:w-5 lg:h-5 hover:primary",
                          "primary"
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doRotate(1, 45)
                        },
                      },
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.auto",
                          value: {
                            content: "Girar sentido anti-horário",
                            delay: { show: 500, hide: 100 },
                            classes: "tooltipZFix",
                          },
                          expression:
                            "{\n              content: 'Girar sentido anti-horário',\n              delay: { show: 500, hide: 100 },\n              classes: 'tooltipZFix'\n            }",
                          modifiers: { auto: true },
                        },
                      ],
                      attrs: {
                        icon: "RotateCcwIcon",
                        svgClasses: _vm.aditionalStyleWhen(
                          _vm.rotatingCCW,
                          "w-8 h-8 lg:w-5 lg:h-5 hover:primary",
                          "primary"
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doRotate(-1, 45)
                        },
                      },
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.auto",
                          value: {
                            content: "Limpar",
                            delay: { show: 500, hide: 100 },
                            classes: "tooltipZFix",
                          },
                          expression:
                            "{\n              content: 'Limpar',\n              delay: { show: 500, hide: 100 },\n              classes: 'tooltipZFix'\n            }",
                          modifiers: { auto: true },
                        },
                      ],
                      attrs: {
                        icon: "XIcon",
                        svgClasses: _vm.aditionalStyleWhen(
                          _vm.rotatingCCW,
                          "w-8 h-8 lg:w-5 lg:h-5 hover:primary",
                          "primary"
                        ),
                      },
                      on: { click: _vm.clearEdits },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "vx-row",
              [
                _c(
                  "vx-col",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "float-right mr-2",
                        attrs: {
                          disabled: !_vm.validDetails,
                          variant: "primary",
                        },
                        on: { click: _vm.updateProfilePicture },
                      },
                      [_vm._v("Salvar")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }